// extracted by mini-css-extract-plugin
export var actionButton = "_cd-5";
export var actionButtonActive = "_cd-6";
export var content = "_cd-3";
export var header = "_cd-4";
export var list = "_cd-7";
export var settingsContent = "_cd-a";
export var settingsPanel = "_cd-b";
export var settingsRow = "_cd-c";
export var state = "_cd-9";
export var triggerBadge = "_cd-2";
export var triggerButton = "_cd-1";
export var triggerShell = "_cd-0";
export var unreadDot = "_cd-8";